export default {
  list: (state) => state.list,
  selected: (state) => state.selected,
  preUploadedFile: (state) => state.preUploadedFile,
};
